<template>

  <div class="page-data-list">
	  
    <b-card no-body>
      <b-card-body>
        <b-form>
    	  <b-row>
    	    <b-col md="6">
    	      <b-form-group :label="$t('Type')">
				<v-select
				    :placeholder="$t('Please select')+$t('Type')"
				    v-model="filter.DataType"
				    :reduce="diagnosisProtocolString => diagnosisProtocolString.diagnosisProtocolIdentifier"
				    label="diagnosisProtocolString"
				    :options="taskTypes"
				/> 
    	      </b-form-group>
    	    </b-col>
    	    <b-col md="6">
    	      <b-form-group :label="$t('Device')">
    	        <v-select
				    :placeholder="$t('Please select')+$t('Device')"
    	            v-model="deviceNameList"
    	            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    	            multiple
    	            label="deviceIdentifier"
    	            :options="taskDevices"
    	        />
    	      </b-form-group>
    	    </b-col>
			
			<!-- 开始时间 -->
			<b-col md="6">
			  <b-form-group :label="$t('Upload Begin Time')">
			    <flat-pickr
				  :placeholder="$t('Please select')+$t('Upload Begin Time')"
			      v-model="filter.UploadBeginTime"
			      class="form-control"
			      :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
			    />
			  </b-form-group>
			</b-col> 
			
			<!-- 结束时间 -->
			<b-col md="6" >
			  <b-form-group :label="$t('Upload Finish Time')" :disabled="filter.UploadBeginTime==null">
			    <flat-pickr
				  :placeholder="$t('Please select')+$t('Upload Finish Time')"
			      v-model="filter.UploadFinishTime"
			      class="form-control"
				  :disable="true"
			      :config="{ enableTime: true,dateFormat: 'Y-m-d H:i', disable:[{from:'1000-01-20',to:filter.UploadBeginTime}]}"
			    />
			  </b-form-group>
			</b-col>
			
			<!-- submit and reset -->
			<b-col md="12">
			  <b-button
			      variant="primary"
			      class="mr-1"
				  @click="onSearch()"
			  >
			    {{$t("Search")}}
			  </b-button>
			  <b-button
			      type="reset"
			      variant="outline-secondary"
				  @click="onReset()"
			  >
				{{$t("Reset")}}
			  </b-button>
			</b-col>
    	  
    	  </b-row>
		  
		</b-form>  
    	  
      </b-card-body>
    </b-card>	
    	
    	
    <b-card no-body>
      <b-form-checkbox-group v-model="checkItems">	
    	<b-table
    	  :items="diagDatas"
    	  responsive
    	  :fields="columns"
    	  show-empty
    	  :empty-text="$t('No matching records found')"
    	  class="position-relative"
		  sort-icon-left
		  @sort-changed="handleSortChange"
    	>
    	   
		  <!-- 列: 选择框 -->
		  <template #cell(#)="data">
		      	
		    <div class="text-nowrap">
				
		      <b-form-checkbox
		        :value="data.item.diagnosisTaskIdentifier"
		      >
		      </b-form-checkbox>  	       
		    </div>
		  </template> 
    	
    	  <!-- 列: Actions -->
    	  <template #cell(actions)="data">
    	
    	    <div class="text-nowrap">
    		  <a 
			  class="view-link"
    		  target="_blank"
    		  :href="apiUrl+'/api/v1/diagdata/viewdata/'+data.item.diagnosisTaskIdentifier"
    		  >
    		    <feather-icon
    		    icon="EyeIcon" />
    		    <span class="align-middle ml-50">{{$t('View')}}</span>	
    		  </a>
			  
			  <a @click="getCsvData(data.item.diagnosisTaskIdentifier)">
			  	<feather-icon class="ml-2" icon="DatabaseIcon" />
			  	<span class="align-middle ml-50">{{$t('CSV Data')}}</span>
			  </a>	
    		  
    		  <a @click="onClickDel(data.index, data.item.diagnosisTaskIdentifier)" v-if="userData.role=='admin'">
    		  	<feather-icon class="ml-2" icon="TrashIcon" />
    		  	<span class="align-middle ml-50">{{$t('Delete')}}</span>
    		  </a>	 
    
    	    </div>
    	  </template>
		  
		  <template #head(#)="data">
		    <b-form-checkbox @change="checkAll" value="all"></b-form-checkbox> 
		  </template>
    	
    	</b-table>
      </b-form-checkbox-group>
		  
	  <b-modal
	    id="modal-csv-data"
	    hide-backdrop
	    ok-only
	    no-close-on-backdrop
	    content-class="shadow"
	    :title="$t('CSV Data')"
	    :ok-title="$t('Close')"
		size="lg"
		centered
	  >
	    <b-table
	      :items="csvDatas"
	      show-empty
	      :empty-text="$t('No matching records found')"
	      class="position-relative modal-height"
		  :fields="csvColumns"
		  fixed
		  responsive
	    >
		  <template #table-colgroup="scope">
		    <col
		      v-for="field in scope.fields"
		      :key="field.key"
		      :style="{ width: setCsvTableColWidth(field.key)+'px' }"
		    >
		  </template>
		
		  <template #cell(dir)="data">
		    {{ data.item.dir==='1'?'Tx':'Rx' }}
		  </template>
		  
	    </b-table>
	  </b-modal>	  
	  
	  <div class="m-2">
	    <b-row>
	  
	  	<!-- 下载 -->
	      <b-col
	        cols="12"
	      >
	        <div class="d-flex align-items-center justify-content-end">
	          <b-button
	            variant="primary"
				@click="downloadData"
	          >
	            {{$t('Download')}}
	          </b-button>
	        </div>
	      </b-col>
	    </b-row>
	  </div>
    	
    	<div class="mx-2 mb-2">
    	    <b-row>
    	      <!-- 页码 -->
    	      <b-col
    	        cols="12"
    	        sm="12"
    	        class="d-flex align-items-center justify-content-center justify-content-sm-start"
    	      >
    	
    	        <b-pagination
    	          v-model="filter.Page"
    	          :total-rows="total"
    	          :per-page="filter.Size"
    	          first-number
    	          last-number
    	          class="mb-0 mt-1 mt-sm-0"
    	          prev-class="prev-item"
    	          next-class="next-item"
    			  @change="onClickPage"
    	        >
    	          <template #prev-text>
    	            <feather-icon
    	              icon="ChevronLeftIcon"
    	              size="18"
    	            />
    	          </template>
    	          <template #next-text>
    	            <feather-icon
    	              icon="ChevronRightIcon"
    	              size="18"
    	            />
    	          </template>
    	        </b-pagination>
    	
    	      </b-col>
    	
    	    </b-row>
    	</div>
    	
    
    
    </b-card>	  
	  
  </div>	
  
</template>

<script>
import {
  BModal, BCard, BCardBody, BForm, BFormCheckbox, BFormCheckboxGroup, BTable, BLink, BDropdown, BDropdownItem, BTooltip, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BButton
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { getDatas, getDataHtml, downloadData, delData, getCsvData } from '@/api/data'
import { getTaskTypes, getTaskDevices } from '@/api/task'
import { getUserData } from '@/utils/auth'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
	BModal,  
    BCard,
	BCardBody,
	BForm,
	BFormCheckbox,
	BFormCheckboxGroup,
	BTable,
	BLink,
	BDropdown,
	BDropdownItem,
	BTooltip,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    ToastificationContent,
	vSelect,
	flatPickr
  },
  data() {
    return {
	  //任务类型列表
	  taskTypes: [],
	  //任务设备
	  taskDevices:[],	
	  //诊断数据列表
	  diagDatas:[],
	  //列表筛选参数
	  filter:{
	    Page:1,
	    Size:20,
		DataType:null,
		DeviceNameList:null,
		UploadBeginTime:null,
		UploadFinishTime:null
	  },
	  deviceNameList:null,
	  //选中项
	  checkItems:[],			  
	  //设备总数
	  total:0,
      columns: [
		'#',  
		{ key: 'diagnosisTaskIdentifier', label: this.$t('Task id'), sortable: true },
		{ key: 'taskName', label: this.$t('Task Name'), sortable: true },
		{ key: 'taskDiagnosisUploadTime', label: this.$t('Upload Time'), sortable: true },
		{ key: 'interpretedResultsXmlFilePathName', label: this.$t('Results Data File'), sortable: true },
		{ key: 'fromDeviceIdentifier', label: this.$t('From Device'), sortable: true },
		{ key: 'actions', label: this.$t('Actions') },
      ],
	  csvColumns: [
		{ key: 'no', label: 'no' },
		{ key: 'deviceID', label: 'deviceID' },
		{ key: 'dir', label: 'dir' },
		{ key: 'rawData', label: 'rawData' },
		{ key: 'address', label: 'address' },
		{ key: 'timeStamp', label: 'timeStamp' },
      ],
	  //用户信息
	  userData:{
	  	role:null,  
	  },
	  //csv数据
	  csvDatas:[],
	  //是否全选
	  isCheckAll:false,
	  apiUrl:null,
    }
  },
  created() {
	this.getTaskTypes()
	this.getTaskDevices()  
    this.getDatas()
	this.userData = getUserData()
	this.apiUrl = $themeConfig.app.apiUrl
  },
  methods: {
	//获取任务类型列表
	getTaskTypes(){
	  getTaskTypes().then(response => {
		this.taskTypes = response.data
	  })
	},
	//获取任务设备列表
	getTaskDevices(){
	  getTaskDevices().then(response => {
	    this.taskDevices = response.data.map(item => item.deviceIdentifier)
	  })
	},  
	//诊断数据列表
	getDatas(){
      getDatas(this.filter).then(response => { 
		this.diagDatas = response.data
		this.total = response.count
      })
    }, 
	//获取csv数据
	getCsvData(taskId){
		window.open('/diagnostic/data/'+taskId)
	  /*this.$bvModal.show('modal-csv-data')	
      getCsvData({taskId}).then(response => { 
	    this.csvDatas = response.data
      })*/
    }, 
	//下载数据
	downloadData(){
	  let checkItems = this.checkItems.filter((item)=>{return item!='all'})	
	  if(checkItems.length<1){
		this.$toast({
		  component: ToastificationContent,
		  position: 'top-right',
		  props: {
		    title: this.$t('Please select'),
		    icon: 'CoffeeIcon',
		    variant: 'danger',
		  },
		})
		return false
	  
	  }	
	  downloadData(checkItems).then(response => { 
		const contentDisposition = response.headers['content-disposition']
		const fileName = decodeURI(contentDisposition.split(';')[1].split('=')[1])
		const link = document.createElement('a')
		const blob = new Blob([response.data])
		link.href = URL.createObjectURL(blob)
		link.download = fileName
		link.click()
	  })
	},  
	
	//删除设备
	onClickDel(index, name){
		
	  this.$bvModal
	    .msgBoxConfirm(this.$t('Please confirm will delete?'), {
	      size: 'sm',
	      okVariant: 'primary',
	      okTitle: this.$t('Confirm'),
	      cancelTitle: this.$t('Cancel'),
	      cancelVariant: 'outline-secondary',
	      hideHeaderClose: false,
	      centered: true,
	    })
	    .then(value => {
	      if(value){
	  		this.diagDatas.splice(index, 1)
	  		delData(name).then(response => {
              this.$toast.success(this.$t('Delete Success'))
            })
	  	  }
	    })	
		  
	},
	//搜索
	onSearch(){
      this.getDatas()
	},
	//重置
	onReset(){
	  this.filter = {
	  	    Page:1,
	  	    Size:20,
	  		DataType:null,
	  		DeviceNameList:null,
	  		UploadBeginTime:null,
	  		UploadFinishTime:null
	  	  }
	  this.deviceNameList = [];
	  this.getDatas()
	},
	//点击分页
	onClickPage(page){
	  this.filter.Page = page
	  this.getDatas()
	},
	//全选
	checkAll(e){
	  this.isCheckAll = !this.isCheckAll
	  if(this.isCheckAll){
	    this.checkItems = this.diagDatas.map(item => item.diagnosisTaskIdentifier)
		this.checkItems.push('all')
	  }
	  else{
	    this.checkItems = []	  
	  }
	},
	//排序
	handleSortChange(e){
	  this.filter.PropertyName = e.sortBy
	  this.filter.IsDesc = e.sortDesc
	  this.diagDatas = []
	  this.getDatas()
	},
	//弹窗表格宽度
	setCsvTableColWidth(col){
	  if(col=='no' || col=='dir'){
		return 50
	  }
	  else if(col=='rawData'){
	    return 240
	  }
	  else if(col=='timeStamp'){
	    return 200
	  }
	  else{
		return 100 
	  }
	}
  },
  watch: {
	//选择设备
    'deviceNameList'(newValue) {
      this.filter.DeviceNameList = newValue.join(',')
    }
  },
}
</script>
<style lang="scss" scoped>

.filter-select {
  min-width: 290px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 200px;
  }
}
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.page-data-list .view-link{
	color: inherit;
}
.modal-height{
	max-height: 400px;
}
</style>
